import Component from './business-display';
export default Component;
